import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import { LuIndianRupee } from "react-icons/lu";
import { BsBookmarkHeart, BsBookmarkHeartFill } from "react-icons/bs";
import HomePageLoader from "../../Components/Loaders/HomePageLoader";
import { useSelector } from "react-redux";

const OfferZone = ({ history }) => {

    const [loading, setLoading] = useState(true)
    const offerPercent = history.location.state.offerPercent
    const [products, setProducts] = useState([])
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn)
    const userDetails = useSelector((state) => state.auth.userDetails)

    useEffect(() => {
        API.get(`/products/getOfferProduct?page=1&limit=20&userId=${userDetails.subject ? userDetails.subject._id : null}&offerPercent=${offerPercent}`).then((homeRes) => {
            setProducts(homeRes.data.data)
            setLoading(false)
        })
    }, [])


    const viewProduct = (value) => {
        history.push(`/product/${value._id}/view`)
        // if (isLoggedIn) {
        // } else {
        //     history.push('/auth/login')
        // }
    }

    const wishList = (value) => {
        let apiValues = {
            productId: value._id,
            addedBy: userDetails.subject._id
        }
        API.post('/products/wishList', apiValues).then((wishRes) => {
            if (wishRes.status === 200) {
                setProducts(products.map((c) => {
                    if (c._id === wishRes.data.data.productId) {
                        c.wishList = [wishRes.data.data]
                    }
                    return c
                }))
            }
        })
    }


    return (
        <motion.div className="relative h-full w-full flex flex-row justify-center">
            {
                loading ? <HomePageLoader /> : <motion.div className="grid grid-cols-1 my-10 md:px-20 sm:grid-cols-1 gap-5 md:gap-10 md:grid-cols-1 xl:grid-cols-4 lg:grid-cols-4">
                    {
                        products && products.map((pro, i) => {
                            return <motion.div key={i} className="relative h-80 w-80 md:w-72 flex flex-col bg-white cursor-pointer drop-shadow-lg">
                                <motion.div className="absolute top-5 right-5 text-xl" onClick={() => wishList(pro)}>{pro.wishList.length > 0 && pro.wishList[0].activeStat === 'A' ? <BsBookmarkHeartFill /> : <BsBookmarkHeart />}</motion.div>
                                <motion.div className="px-2 py-2 h-60 flex flex-row justify-center" onClick={() => viewProduct(pro)}>
                                    <img src={pro.images[0].imageUrl} width={400} alt="preview" />
                                </motion.div>
                                <motion.div className="px-2 my-1 flex-row flex items-center font-bold text-xl" onClick={() => viewProduct(pro)}>
                                    <LuIndianRupee />{pro.offerPercentage === 0 ? pro.price : pro.price * (pro.offerPercentage / 100)}
                                </motion.div>
                                <motion.div className="px-2 my-1 flex flex-row text-primeColor/40" onClick={() => viewProduct(pro)}>
                                    {pro.productName}
                                </motion.div>
                            </motion.div>
                        })
                    }
                </motion.div>}
        </motion.div>
    )
}

export default OfferZone